export default __webpack_public_path__ + "static/useful1-a816ac0ccea97b61af488c1e8e8617ad.jpeg";